export default __webpack_public_path__ + "static/media/enclaves.4abd0493.webm";